import React from 'react';
import { Link } from 'react-router-dom';

const BreadCrumb = ({ title, pageTitle }) => {
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: "0.75rem",
                marginBottom: "1.25rem",
            }}
        >
            <h1
                className="bl-gradient-text"
                style={{
                    margin: 0,
                    fontFamily: "var(--bl-font-display)",
                    fontSize: "clamp(1.5rem, 4vw, 2rem)",
                    fontWeight: 700,
                    letterSpacing: "-0.01em",
                }}
            >
                {title}
            </h1>
            {pageTitle && (
                <ol
                    style={{
                        listStyle: "none",
                        margin: 0,
                        padding: 0,
                        display: "flex",
                        gap: "0.4rem",
                        fontSize: 13,
                        alignItems: "center",
                    }}
                >
                    <li>
                        <Link to="#" style={{ color: "var(--bl-text-soft)", textDecoration: "none" }}>
                            {pageTitle}
                        </Link>
                    </li>
                    <li style={{ color: "var(--bl-text-faint)" }}>/</li>
                    <li style={{ color: "var(--bl-text-strong)" }}>{title}</li>
                </ol>
            )}
        </div>
    );
};

export default BreadCrumb;
